import { Button } from '@mui/material';
import styled from 'styled-components';

const CustomButton = styled(Button)`
  width: 100%;
  border-radius: 100px !important;
  padding: ${(props) => (props.padding ? props.padding : `0.25rem 2rem !important`)};
  text-transform: none !important;
  ${(props) => props.variant === 'contained' && `background-color: #0997ba !important;`}
  ${(props) =>
    props.variant === 'outlined' &&
    `color: #0997ba !important; border-color: #0997ba !important; background-color: white !important;`}
`;

export default CustomButton;
